/* eslint-disable unused-imports/no-unused-vars */
import axios from '@axios'
import { defineStore } from '@/@core/utils/vuex'

const anyArr = () => [] as any[]
export default defineStore({
    namespaced: true,
    state: {
        /* Secuenciales Transacción */
        secuencialesTransaccion: [],

        /* Sustento Tributario */
        sustentosTributarios: [],

        /* Partidas Arancelarias */
        partidasArancelarias: [],

        /* Sutento Form 104 */
        sustentosForm104: [],

        /* Código Form 104 */
        codigoForm104: null,

        /* Porcentajes IVA */
        porcentajesIVA: [],

        /* Grupos IVA */
        gruposIVA: [],

        /* Asignación de grupo de IVA */
        asignacionGruposIVA: [],

        /* Porcentaje IVA */
        porcentajeIva: null,

        /* Conceptos AIR */
        conceptosAIR: [],

        /* Retenciones IVA */
        retencionesIVA: [],

        /* Tipo Comprobante */
        tiposComprobante: [],

        /* Tipo Pago */
        tiposPago: [],

        /* Forma Pago Cobro */
        formasPagoCobro: [],

        /* Comprobantes Autorizados */
        comprobanteSustento: [],
        comprobanteTransaccion: [],

        /* Usuarios */
        usuarios: [],

        /* Control de errores */
        controlErrores: anyArr(),
        variables: anyArr(),
        porcentajeDiscapacidad: [],
        deducciones: [],
        formatoRDEP: [],
        impuestoRenta: [],
        variableId: [],
        campoFormato107: [],
        ficha: [],
        detalleCalculo: [],
        total: 0,
        detalleSinCalculoExistente: [],
        detalleSinCalculo: [],
        exportExcel: [],
        datoEmpleado: [],
        formato107: [],
        fichaXML: [],
        formato107SinCalculo: [],
        informeEmpleado: [],
        informeEmpleadoSinCalculo: [],
        detalleTabla: [],
        detalleTablaSinCalculo: [],
        resumenEmpleado: [],
        resumenEmpleadoSinCalculo: [],
        resumenDivision: [],
        resumenDivisionSinCalculo: [],
        codigoTransaccion: [],
        CodigoIdentificacion: [],
        CodigosRegimen: [],
        periodoEstablecimientosUserATS: [],

        /* Distrito Aduanero */
        distritosAduaneros: [],

        /* Tipos Exportación */
        tiposExportacion: [],

        /* Punto Emisión */
        puntosEmision: [],

        /* País */
        paises: [],

        /* Formato 103 */
        formato103: [],
        resumen103: [],

        /* facturasComprasATS */
        facturasComprasATS: [],

        /* Reporte Formulario 104 */
        reporteForm104: [],

        /* Reporte XML ATS */
        reporteXmlAts: [],

        /* ciudades */
        ciudades: [],

        /* Provincias */
        provincias: [],

        /* Fideicomisos */
        fideicomisos: [],

        tipoContribuyente: [],

        /* mantenimiento codigo form103 */
        codigoForm103: [],

        porcentajeIvaGeneral: [],

        porcentajeMatrizRetencion: [],
    },
    getters: {
        /* Secuenciales Transacción */
        getSecuencialesTransaccion(state) {
            return state.secuencialesTransaccion
        },

        /* Sustento Tributario */
        getSustentosTributarios(state) {
            return state.sustentosTributarios
        },

        /* Partidas Arancelarias */
        getPartidasArancelarias(state) {
            return state.partidasArancelarias
        },

        /* Sustento Form 104 */
        getSustentosForm104(state) {
            return state.sustentosForm104
        },

        /* Código Form 104 */
        getCodigoForm104(state) {
            return state.codigoForm104
        },

        /* Porcentajes IVA */
        getPorcentajesIva(state) {
            return state.porcentajesIVA
        },

        /* Porcentaje IVA */
        getPorcentajeIva(state) {
            return state.porcentajeIva
        },

        /* Grupos IVA */
        getGruposIVA(state) {
            return state.gruposIVA
        },

        /* Asignación de Grupos IVA */
        getAsignacionGruposIVA(state) {
            return state.asignacionGruposIVA
        },

        /* Conceptos AIR */
        getConceptosAIR(state) {
            return state.conceptosAIR
        },

        /* Retenciones IVA */
        getRetencionesIVA(state) {
            return state.retencionesIVA
        },

        /* Tipo Comprobante */
        getTiposComprobante(state) {
            return state.tiposComprobante
        },

        /* Tipo Pago */
        getTiposPago(state) {
            return state.tiposPago
        },

        /* Forma Pago Cobro */
        getFormasPagoCobro(state) {
            return state.formasPagoCobro
        },

        /* Comprobantes Autorizados */
        getComprobanteSustento(state) {
            return state.comprobanteSustento
        },

        getComprobanteTransaccion(state) {
            return state.comprobanteTransaccion
        },

        /* Usuarios */
        getUsuarios(state) {
            return state.usuarios
        },

        /* Control de errores */
        getControlErrores(state) {
            return state.controlErrores
        },
        getVariables(state) {
            return state.variables
        },

        getPorcentajeDiscapacidad(state) {
            return state.porcentajeDiscapacidad
        },

        getDeducciones(state) {
            return state.deducciones
        },

        getFormatoRDEP(state) {
            return state.formatoRDEP
        },

        getImpuestoRenta(state) {
            return state.impuestoRenta
        },

        getVariableId(state) {
            return state.variableId
        },

        getCamposFormato107(state) {
            return state.campoFormato107
        },

        getFicha(state) {
            return state.ficha
        },

        getDetalleCalculo(state) {
            return state.detalleCalculo
        },

        getDetalleSinCalculoExixtente(state) {
            return state.detalleSinCalculoExistente
        },

        getDetalleSinCalculo(state) {
            return state.detalleSinCalculo
        },

        getDatoEmpleado(state) {
            return state.datoEmpleado
        },

        getFormato107(state) {
            return state.formato107
        },

        getFichaXML(state) {
            return state.fichaXML
        },

        getFormato107SinCalculo(state) {
            return state.formato107SinCalculo
        },

        getInformeEmpleado(state) {
            return state.informeEmpleado
        },

        getInformeEmpleadoSinCalculo(state) {
            return state.informeEmpleadoSinCalculo
        },

        getDetalleTabla(state) {
            return state.detalleTabla
        },

        getDetalleTablaSinCalculo(state) {
            return state.detalleTablaSinCalculo
        },

        getResumenEmpleado(state) {
            return state.resumenEmpleado
        },

        getResumenEmpleadoSinCalculo(state) {
            return state.resumenEmpleadoSinCalculo
        },

        getResumenDivision(state) {
            return state.resumenDivision
        },

        getResumenDivisionSinCalculo(state) {
            return state.resumenDivisionSinCalculo
        },

        getCodigosTransaccion(state) {
            return state.codigoTransaccion
        },

        /* Tipo Identificación */
        getCodigoIdentificacion(state) {
            return state.CodigoIdentificacion
        },

        /* Códigos Régimen */
        getCodigosRegimen(state) {
            return state.CodigosRegimen
        },

        /* Distrito Aduanero */
        getDistritosAduaneros(state) {
            return state.distritosAduaneros
        },

        /* Tipos Exportación */
        getTiposExportacion(state) {
            return state.tiposExportacion
        },

        /* Punto Emisión */
        getPuntosEmision(state) {
            return state.puntosEmision
        },

        /* País */
        getPaises(state) {
            return state.paises
        },
        getFormato103(state) {
            return state.formato103
        },

        getResumen103(state) {
            return state.resumen103
        },

        getFacturasComprasATS(state) {
            return state.facturasComprasATS
        },

        /* Reporte Formulario 104 */
        getReporteForm104(state) {
            return state.reporteForm104
        },

        getPeriodoEstablecimientosUserATS(state) {
            return state.periodoEstablecimientosUserATS
        },

        getCiudades(state) {
            return state.ciudades
        },

        getFideicomisos(state) {
            return state.fideicomisos
        },

        getProvincias(state) {
            return state.provincias
        },

        getTipoContribuyente(state) {
            return state.tipoContribuyente
        },

        /* Código Form 103 */
        getCodigoForm103(state) {
            return state.codigoForm103
        },

        getPorcentajeIvaGeneral(state) {
            return state.porcentajeIvaGeneral
        },

        getPorcentajeMatrizRetencion(state) {
            return state.porcentajeMatrizRetencion
        },
    },
    mutations: {
        /* Secuenciales Transacción */
        setSecuencialesTransaccion(state, secuencialesTransaccion) {
            state.secuencialesTransaccion = secuencialesTransaccion
        },

        /* Sustento Tributario */
        setSustentosTributarios(state, sustentosTributarios) {
            state.sustentosTributarios = sustentosTributarios
        },

        /* Sustento Tributario */
        setPartidasArancelarias(state, partidasArancelarias) {
            state.partidasArancelarias = partidasArancelarias
        },

        /* Sustento Form104 */
        setSustentosForm104(state, sustentosForm104) {
            state.sustentosForm104 = sustentosForm104
        },

        /* Código Form104 */
        setCodigoForm104(state, codigoForm104) {
            state.codigoForm104 = codigoForm104
        },

        /* Porcentajes IVA */
        setPorcentajesIVA(state, porcentajesIVA) {
            state.porcentajesIVA = porcentajesIVA
        },

        setPorcentajeIva(state, porcentajeIva) {
            state.porcentajeIva = porcentajeIva
        },

        /* Grupos IVA */
        setGruposIVA(state, gruposIVA) {
            state.gruposIVA = gruposIVA
        },

        /* Asignación Grupos IVA */
        setAsignacionGruposIVA(state, asignacionGruposIVA) {
            state.asignacionGruposIVA = asignacionGruposIVA
        },

        /* Conceptos AIR */
        setConceptosAIR(state, conceptosAIR) {
            state.conceptosAIR = conceptosAIR
        },

        /* Retenciones IVA */
        setRetencionesIVA(state, retencionesIVA) {
            state.retencionesIVA = retencionesIVA
        },

        /* Tipo Comprobante */
        setTiposComprobante(state, tiposComprobante) {
            state.tiposComprobante = tiposComprobante
        },

        /* Tipo Paog */
        setTiposPago(state, tiposPago) {
            state.tiposPago = tiposPago
        },

        /* Forma Pago Cobro */
        setFormasPagoCobro(state, formasPagoCobro) {
            state.formasPagoCobro = formasPagoCobro
        },

        /* Comprobantes Autorizados */
        setComprobanteSustento(state, comprobanteSustento) {
            state.comprobanteSustento = comprobanteSustento
        },

        setComprobanteTransaccion(state, comprobanteTransaccion) {
            state.comprobanteTransaccion = comprobanteTransaccion
        },

        /* Usuarios */
        setUsuarios(state, usuarios) {
            state.usuarios = usuarios
        },

        /* Control de errores */
        setControlErrores(state, controlErrores) {
            state.controlErrores = controlErrores
        },
        setVariables(state, variables) {
            state.variables = variables
        },

        setPorcentajeDiscapacidad(state, porcentajeDiscapacidad) {
            state.porcentajeDiscapacidad = porcentajeDiscapacidad
        },

        setDeducciones(state, deducciones) {
            state.deducciones = deducciones
        },

        setFormatoRDEP(state, formatoRDEP) {
            state.formatoRDEP = formatoRDEP
        },

        setImpuestoRenta(state, impuestoRenta) {
            state.impuestoRenta = impuestoRenta
        },

        setVariableId(state, variableId) {
            state.variableId = variableId
        },

        setEstadoVariable(state, registroId) {
            const detalle = state.variables.find(p => p?.id_variable === registroId)
            if (typeof detalle === 'object') {
                detalle.activo = 0
            }
        },

        setCampoFormato107(state, campoFormato107) {
            state.campoFormato107 = campoFormato107
        },

        setFicha(state, ficha) {
            state.ficha = ficha
        },

        setDetalleCalculo(state, detalleCalculo) {
            state.detalleCalculo = detalleCalculo
        },

        setTotal(state, total) {
            state.total = total
        },

        setDetalleSinCalculoExistente(state, detalleSinCalculoExistente) {
            state.detalleSinCalculoExistente = detalleSinCalculoExistente
        },

        setDetalleSinCalculo(state, detalleSinCalculo) {
            state.detalleSinCalculo = detalleSinCalculo
        },

        setDatoEmpleado(state, datoEmpleado) {
            state.datoEmpleado = datoEmpleado
        },

        setFormato107(state, formato107) {
            state.formato107 = formato107
        },

        setFichaXML(state, fichaXML) {
            state.fichaXML = fichaXML
        },

        setFormato107SinCalculo(state, formato107SinCalculo) {
            state.formato107SinCalculo = formato107SinCalculo
        },

        setInformeEmpleado(state, informeEmpleado) {
            state.informeEmpleado = informeEmpleado
        },

        setInformeEmpleadoSinCalculo(state, informeEmpleadoSinCalculo) {
            state.informeEmpleadoSinCalculo = informeEmpleadoSinCalculo
        },

        setDetalleTabla(state, detalleTabla) {
            state.detalleTabla = detalleTabla
        },

        setDetalleTablaSinCalculo(state, detalleTablaSinCalculo) {
            state.detalleTablaSinCalculo = detalleTablaSinCalculo
        },

        setResumenEmpleado(state, resumenEmpleado) {
            state.resumenEmpleado = resumenEmpleado
        },

        setResumenEmpleadoSinCalculo(state, resumenEmpleadoSinCalculo) {
            state.resumenEmpleadoSinCalculo = resumenEmpleadoSinCalculo
        },

        setResumenDivision(state, resumenDivision) {
            state.resumenDivision = resumenDivision
        },

        setResumenDivisionSinCalculo(state, resumenDivisionSinCalculo) {
            state.resumenDivisionSinCalculo = resumenDivisionSinCalculo
        },

        setTotalSinCalculo(state, data) {
            // TODO: HAZ ESTO KEYKOSSS
        },

        /* Tipo Transacción */
        setCodigoTransaccion(state, codigoTransaccion) {
            state.codigoTransaccion = codigoTransaccion
        },

        /* Tipo Identificación */
        setCodigoIdentificacion(state, CodigoIdentificacion) {
            state.CodigoIdentificacion = CodigoIdentificacion
        },

        /* Código Régimen */
        setCodigosRegimen(state, CodigosRegimen) {
            state.CodigosRegimen = CodigosRegimen
        },

        /* Distrito Aduanero */
        setDistritosAduaneros(state, distritosAduaneros) {
            state.distritosAduaneros = distritosAduaneros
        },

        /* Tipos Exportación */
        setTiposExportacion(state, tiposExportacion) {
            state.tiposExportacion = tiposExportacion
        },

        /* Punto Emisión */
        setPuntosEmision(state, puntosEmision) {
            state.puntosEmision = puntosEmision
        },

        /* País */
        setPaises(state, paises) {
            state.paises = paises
        },
        setFormato103(state, formato103) {
            state.formato103 = formato103
        },

        setResumen103(state, resumen103) {
            state.resumen103 = resumen103
        },

        setFacturasComprasATS(state, facturasComprasATS) {
            state.facturasComprasATS = facturasComprasATS
        },

        /* Reporte Formulario 104 */
        setReporteFormulario104(state, reporteFormulario104) {
            state.reporteForm104 = reporteFormulario104
        },

        /* XML ATS */
        setReporteXmlAts(state, reporteXmlAts) {
            state.reporteXmlAts = reporteXmlAts
        },

        setPeriodoEstablecimientosUserATS(state, periodoEstablecimientosUserATS) {
            state.periodoEstablecimientosUserATS = periodoEstablecimientosUserATS
        },

        setCiudades(state, ciudades) {
            state.ciudades = ciudades
        },

        setFideicomisos(state, fideicomisos) {
            state.fideicomisos = fideicomisos
        },

        setProvincias(state, provincias) {
            state.provincias = provincias
        },

        setTipoContribuyente(state, tipoContribuyente) {
            state.tipoContribuyente = tipoContribuyente
        },

        setCodigoForm103(state, codigoForm103) {
            state.codigoForm103 = codigoForm103
        },

        setPorcentajeIvaGeneral(state, porcentajeIvaGeneral) {
            state.porcentajeIvaGeneral = porcentajeIvaGeneral
        },

        setPorcentajeMatrizRetencion(state, porcentajeMatrizRetencion) {
            state.porcentajeMatrizRetencion = porcentajeMatrizRetencion
        },
    },

    actions: {
        async fetchVariable({ commit }, params) {
            const response = await axios.get('/api/auth/v2/tributacion/variables', { params })
            commit('setVariables', response.data)
            return response
        },

        /* Secuenciales Transacción */
        async fetchPorcentajeDiscapacidad({ commit }, params) {
            const response = await axios.get('/api/auth/v2/tributacion/porcentaje-discapacidad', { params })
            commit('setPorcentajeDiscapacidad', response.data)
            return response
        },

        fetchDeduccion({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/deducciones', { params })
                    .then(response => {
                        commit('setDeducciones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Sustentos Tributarios */
        fetchSustentosTributarios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/sustento-tributario', { params: data })
                    .then(response => {
                        commit('setSustentosTributarios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSustentoTributarioById({ commit }, id_sustento_tributario) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/sustento-tributario/${id_sustento_tributario}`)
                    .then(response => {
                        commit('setSustentosTributarios', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSustentoTributario({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/sustento-tributario', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSustentoTributario({ commit }, { id_sustento_tributario, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/sustento-tributario/${id_sustento_tributario}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarSustentoTributario({ commit }, id_sustento_tributario) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/sustento-tributario/${id_sustento_tributario}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchFormatoRDEP({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/formatoRDEP', { params })
                    .then(response => {
                        commit('setFormatoRDEP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Códigod Form104 */
        fetchCodigoForm104({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/formulario-104', { params: data })
                    .then(response => {
                        commit('setCodigoForm104', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Partida Arancelaria */
        fetchPartidasArancelarias({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/partida-arancelaria')
                    .then(response => {
                        commit('setPartidasArancelarias', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearCodigoForm104({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/formulario-104', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarCodigoForm104({ commit }, { id_codigo_form104, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/formulario-104/${id_codigo_form104}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarCodigoForm104({ commit }, id_codigo_form104) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/formulario-104/${id_codigo_form104}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchImpuestoRenta({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/impuestoRenta', { params })
                    .then(response => {
                        commit('setImpuestoRenta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Sustentos Form104 */
        fetchSustentosForm104({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/sustento-form104', { params: data })
                    .then(response => {
                        commit('setSustentosForm104', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Porcentajes IVA */
        fetchPorcentajesIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/porcentaje-iva', { params: data })
                    .then(response => {
                        commit('setPorcentajesIVA', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarPorcentajesIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/porcentaje-iva', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarPorcentajesIVA({ commit }, { id_porcentaje_iva, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/porcentaje-iva/${id_porcentaje_iva}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCambiarEstadoPorcentajeIVA({ commit }, id_porcentaje_iva) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/porcentaje-iva/${id_porcentaje_iva}/cambiar-estado`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPorcentajeIva({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/porcentaje-iva', { params: { actual: true } })
                    .then(response => {
                        commit('setPorcentajeIva', response.data.data[0])
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Grupos IVA */
        fetchGruposIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/grupo-iva', { params: data })
                    .then(response => {
                        commit('setGruposIVA', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGrupoIVAById({ commit }, idGrupoIva) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/grupo-iva/${idGrupoIva}`)
                    .then(response => {
                        commit('setGruposIVA', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarGruposIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/grupo-iva', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchActualizarDetalleGruposIVA({ commit }, { id_grupo_iva, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/grupo-iva/${id_grupo_iva}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEliminarGrupoIVA({ commit }, { id_grupo_iva }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/grupo-iva/${id_grupo_iva}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Asignación Grupos IVA */
        fetchAsignacionGruposIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/asignacion-grupo-iva', { params: data })
                    .then(response => {
                        commit('setAsignacionGruposIVA', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Retenciones IVA */
        fetchRetencionesIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/retencion-iva', { params: data })
                    .then(response => {
                        commit('setRetencionesIVA', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        createRetencionIVA({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/retencion-iva', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        updateRetencionIVA({ commit }, { id_retencion_iva, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/retencion-iva/${id_retencion_iva}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        deleteRetencionIVA({ commit }, id_retencion_iva) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/retencion-iva/${id_retencion_iva}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Tipos Comprobante */
        fetchTiposComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-comprobante', { params: data })
                    .then(response => {
                        commit('setTiposComprobante', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearTipoComprobante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/tipo-comprobante', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarTipoComprobante({ commit }, { id_tipo_comprobante, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/tipo-comprobante/${id_tipo_comprobante}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarTipoComprobante({ commit }, id_tipo_comprobante) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/tipo-comprobante/${id_tipo_comprobante}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Tipos Pago */
        fetchTiposPago({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-pago', { params: data })
                    .then(response => {
                        commit('setTiposPago', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Formas Pago Cobro */
        fetchFormasPagoCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/forma-pago-cobro', { params: data })
                    .then(response => {
                        commit('setFormasPagoCobro', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearFormaPagoCobro({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/forma-pago-cobro', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarFormaPagoCobro({ commit }, { id_forma_pago_cobro, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/forma-pago-cobro/${id_forma_pago_cobro}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarFormaPagoCobro({ commit }, id_forma_pago_cobro) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/forma-pago-cobro/${id_forma_pago_cobro}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Comprobantes Autorizados */
        fetchComprobanteSustento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/comprobante-autorizado/sustento', { params: data })
                    .then(response => {
                        commit('setComprobanteSustento', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchComprobanteTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/comprobante-autorizado/transaccion', { params: data })
                    .then(response => {
                        commit('setComprobanteTransaccion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postComprobanteSustento({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/comprobante-autorizado/sustento', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postComprobanteTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/comprobante-autorizado/transaccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        destroyComprobanteSustento({ commit }, id_comprobante_sustento) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/comprobante-autorizado/sustento/${id_comprobante_sustento}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        destroyComprobanteTransaccion({ commit }, id_comprobante_transaccion) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(
                        `/api/auth/v2/tributacion/sri/comprobante-autorizado/transaccion/${id_comprobante_transaccion}`
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* RDEP - Por factorizar (algún día) */
        fetchDatoEmpleado({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/datoEmpleado')
                    .then(response => {
                        commit('setDatoEmpleado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Variables tributacion
        // Crear Variable
        crearVariable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/variables/crearVariable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Buscar variable por id
        fetchVariableId({ commit }, registroId) {
            // console.log(registroId);
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/variables/getVariable/${registroId}`)
                    .then(response => {
                        commit('setVariableId', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Modificar variable
        modificarRegistroVariable({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/v2/tributacion/variables/editarRegistroVariable', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Control de errores */
        fetchControlErrores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/reportes/control-errores', {
                        params: {
                            paginated: data.paginated,
                            id_usuario: data.usuario.id,
                            per_page: data.pagination.per_page,
                            current_page: data.pagination.current_page,
                        },
                    })
                    .then(response => {
                        commit('setControlErrores', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Eliminar Variable
        eliminarVariable({ commit }, registroId) {
            // console.log(registroId);
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/variables/eliminarVariable', { registroId })
                    .then(response => {
                        commit('setEstadoVariable', registroId)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postControlErrores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/control-errores', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Porcentaje discapacidad

        // Crear porcentaje discapacidad
        crearPorcentajeDiscapacidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/porcentaje-discapacidad/crearPorcentajeDiscapacidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Buscar porcentaje por id
        fetchPorcentajeDiscapacidadId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/porcentaje-discapacidad/getPorcentajeDiscapacidad/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Modificar porcentaje discapacidad
        modificarPorcentajeDiscapacidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/v2/tributacion/porcentaje-discapacidad/editarPorcentajeDiscapacidad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Eliminar porcentaje discapacidad
        eliminarPorcentajeDiscapacidad({ commit }, registroId) {
            // console.log(registroId);

            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/porcentaje-discapacidad/eliminarPorcentajeDiscapacidad', {
                        registroId,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Deducciones
        // Crear deduccion
        crearDeduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/deducciones/crearDeduccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Buscar deduccion por id
        fetchDeduccionId({ commit }, registroId) {
            // console.log(registroId);
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/deducciones/getDeduccion/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Editar deducciones
        modificarRegistroDeduccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/v2/tributacion/deducciones/editarDeduccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Eliminar deduccion
        eliminarDeduccion({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/deducciones/eliminarDeduccion', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Impuesto a la renta
        // Crear IR
        crearImpuestoRenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/impuestoRenta/crearImpuestoRenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Buscar IR por id
        fetchImpuestoRentaId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/impuestoRenta/getImpuestoRenta/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Modificar IR
        modificarRegistroImpuestoRenta({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/v2/tributacion/impuestoRenta/editarImpuestoRenta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Eliminar IR
        eliminarImpuestoRenta({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/impuestoRenta/eliminarImpuestoRenta', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Formato RDEP
        // Crear formaro
        crearFormatoRDEP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/formatoRDEP/crearFormatoRDEP', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Buscar formato por id
        fetchFormatoRDEPId({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/formatoRDEP/getFormatoRDEP/${registroId}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Modificar formato RDEP
        modificarFormatoRDEP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .put('/api/auth/v2/tributacion/formatoRDEP/editarFormatoRDEP', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Eliminar Formato RDEP
        eliminarFormatoRDEP({ commit }, registroId) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/formatoRDEP/eliminarFormatoRDEP', { registroId })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // formato 107 - tabla rdep_formato
        fetchCamposFormato107({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/formatoRDEP/camposFormato107')
                    .then(response => {
                        commit('setCampoFormato107', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // ficha
        fetchFicha({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/formatoRDEP/ficha')
                    .then(response => {
                        commit('setFicha', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Detalle con calculo
        fetchDetalleCalculoRDEP({ commit }, anio) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/detalleCalculoRDEP/detalleCalculo?anio=${anio}`)
                    .then(response => {
                        commit('setDetalleCalculo', response.data)
                        commit('setTotal', response.data.total)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchDetalleSinCalculoExistente({ commit }, data) {
            // console.log(data);
            const response = await axios.get(
                '/api/auth/v2/tributacion/detalleSinCalculoRDEP/detalleSinCalculoExistente',
                {
                    params: data,
                }
            )
            commit('setDetalleSinCalculoExistente', response.data)
            return response
        },

        // tabla sin calculos
        fetchDetalleSinCalculo({ commit }, anio) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/detalleSinCalculoRDEP/detalleSinCalculo?anio=${anio}`)
                    .then(response => {
                        commit('setDetalleSinCalculo', response.data)
                        commit('setTotalSinCalculo', response.data.total)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // Empleado
        postInformacionEmpleado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/datoEmpleado/agregarDatoEmpleado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEmpleadoSinCalculo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/detalleSinCalculoRDEP/agregarEmpleadoSinCalculo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postEmpleadoCalculo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/detalleCalculoRDEP/agregarEmpleadoConCalculo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async getFecha() {
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/getFecha')
            return response
        },
        // Pantalla "Reporte Formulario 107"
        async fetchFormato107({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/detalleCalculoRDEP/formato107', { params: data })
            commit('setFormato107', response.data)
            return response
        },

        fetchFichaXML({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/formatoRDEP/fichaXML')
                    .then(response => {
                        commit('setFichaXML', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchFormato107SinCalculo({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/detalleSinCalculoRDEP/formato107SinCalculo', {
                params: data,
            })
            commit('setFormato107SinCalculo', response.data)
            return response
        },

        // Pantalla RDEP_Procesos

        async fetchEmpleadoCompleto({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/empleadoCompleto', { params: data })
            commit('setInformeEmpleado', response.data)
            return response
        },

        async fetchEmpleadoCompletoSinCalculo({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/empleadoCompletoSinCalculo', {
                params: data,
            })
            commit('setInformeEmpleadoSinCalculo', response.data)
            return response
        },

        // Pantalla Reportes Tabulados RDEP

        async fetchDetalleTabla({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/detalleCalculoRDEP/resumenDetallado', {
                params: data,
            })
            commit('setDetalleTabla', response.data)
            return response
        },
        async fetchDetalleTablaExcel({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/detalleCalculoRDEP/resumenDetallado/excel', {
                params: data,
                responseType: 'blob',
            })
            return response
        },

        async fetchDetalleTablaSinCalculo({ commit }, data) {
            // console.log(data);
            const response = await axios.get(
                '/api/auth/v2/tributacion/detalleSinCalculoRDEP/resumenDetalladoSinCalculo',
                {
                    params: data,
                }
            )
            commit('setDetalleTablaSinCalculo', response.data)
            return response
        },
        async fetchDetalleTablaExcelSinCalculo({ commit }, data) {
            // console.log(data);
            const response = await axios.get(
                '/api/auth/v2/tributacion/detalleSinCalculoRDEP/resumenDetalladoSinCalculo/excel',
                {
                    params: data,
                    responseType: 'blob',
                }
            )
            return response
        },

        async fetchResumenEmpleado({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/resumenEmpleado', { params: data })
            commit('setResumenEmpleado', response.data)
            return response
        },

        async fetchResumenEmpleadoSinCalculo({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/resumenEmpleadoSinCalculo', {
                params: data,
            })
            commit('setResumenEmpleadoSinCalculo', response.data)
            return response
        },

        async fetchResumenDivision({ commit }, data) {
            // console.log(data);
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/resumenDivision', { params: data })
            commit('setResumenDivision', response.data)
            return response
        },

        async fetchResumenDivisionSinCalculo({ commit }, data) {
            const response = await axios.get('/api/auth/v2/tributacion/datoEmpleado/resumenDivisionSinCalculo', {
                params: data,
            })
            commit('setResumenDivisionSinCalculo', response.data)
            return response
        },

        /* Mantenimiento Tipo Transaccion */
        fetchCodigoTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-transaccion', { params: data })
                    .then(response => {
                        commit('setCodigoTransaccion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Mantenimiento Tipo Identificación */
        fetchCodigoIdentificacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-identificacion', { params: data })
                    .then(response => {
                        commit('setCodigoIdentificacion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Mantenimiento Secuencial Transacción */
        fetchSecuencialesTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/secuencial-transaccion', { params: data })
                    .then(response => {
                        commit('setSecuencialesTransaccion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearSecuencialTransaccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/secuencial-transaccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSecuencialTransaccionById({ commit }, data) {
            const id_secuencial_transaccion = data.id_secuencial_transaccion ?? data.codigo
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/secuencial-transaccion/${id_secuencial_transaccion}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarSecuencialTransaccion({ commit }, { id_secuencial_transaccion, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/secuencial-transaccion/${id_secuencial_transaccion}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarSecuencialTransaccion({ commit }, id_secuencial_transaccion) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/secuencial-transaccion/${id_secuencial_transaccion}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Código Régimen */
        fetchCodigosRegimen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/regimen-fiscal`, { params: data })
                    .then(response => {
                        commit('setCodigosRegimen', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearCodigoRegimen({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/regimen-fiscal', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarCodigoRegimen({ commit }, { id_regimen_fiscal, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/regimen-fiscal/${id_regimen_fiscal}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarCodigoRegimen({ commit }, id_regimen_fiscal) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/regimen-fiscal/${id_regimen_fiscal}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Distrito Aduanero */
        fetchDistritosAduaneros({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/distrito-aduanero', { params: data })
                    .then(response => {
                        commit('setDistritosAduaneros', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearDistritoAduanero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/distrito-aduanero', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarDistritoAduanero({ commit }, { id_distrito_aduanero, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/distrito-aduanero/${id_distrito_aduanero}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarDistritoAduanero({ commit }, id_distrito_aduanero) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/distrito-aduanero/${id_distrito_aduanero}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Tipos Exportación */
        fetchTiposExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-exportacion', { params: data })
                    .then(response => {
                        commit('setTiposExportacion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearTipoExportacion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/tipo-exportacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarTipoExportacion({ commit }, { id_tipo_exportacion, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/tipo-exportacion/${id_tipo_exportacion}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarTipoExportacion({ commit }, id_tipo_exportacion) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/tipo-exportacion/${id_tipo_exportacion}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Cierre SRI */
        fetchCodigoCierreSRI({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/cierre-sri', { params: data })
                    .then(response => {
                        commit('setPeriodoEstablecimientosUserATS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Punto Emisión */
        fetchPuntosEmision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/punto-emision', { params: data })
                    .then(response => {
                        commit('setPuntosEmision', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPuntosEmisionById({ commit }, id_punto_emision) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/punto-emision/${id_punto_emision}`)
                    .then(response => {
                        commit('setPuntosEmision', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearPuntoEmision({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/punto-emision', data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarPuntoEmision({ commit }, { id_punto_emision, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/punto-emision/${id_punto_emision}`, data)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarPuntoEmision({ commit }, id_punto_emision) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/punto-emision/${id_punto_emision}`)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* País */
        fetchPaises({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/pais', { params: data })
                    .then(response => {
                        commit('setPaises', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPaisById({ commit }, id_pais) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/pais/${id_pais}`)
                    .then(response => {
                        commit('setPaises', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearPais({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/pais', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarPais({ commit }, { id_pais, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/pais/${id_pais}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarPais({ commit }, id_pais) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/pais/${id_pais}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // formato 103
        async fetchFormato103({ commit }, data) {
            const response = await axios.get('/api/auth/v2/tributacion/reportes/formato-103', { params: data })
            commit('setFormato103', response.data)
            return response
        },

        async fetchResumen103({ commit }, data) {
            const response = await axios.get('/api/auth/v2/tributacion/reportes/formato-103/resumen103', {
                params: data,
            })
            commit('setResumen103', response.data)
            return response
        },

        /* FacturasComprasATS */
        fetchFacturasComprasATSFiltered({ commit }, data) {
            return new Promise((resolve, reject) => {
                const url = '/api/auth/v2/tributacion/ats/transacciones/facturas'
                axios
                    .get(url, {
                        params: {
                            id_tipo_comprobante: data.id_tipo_comprobante,
                            id_establecimiento: data.id_establecimiento,
                            id_sustento_tributario: data.id_sustento_tributario,
                            id_proveedor: data.id_proveedor,
                            periodo: data.periodo,
                            per_page: data.pagination.per_page,
                            current_page: data.pagination.current_page,
                        },
                    })
                    .then(response => {
                        commit('setFacturasComprasATS', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Reporte Formulario 104 */
        fetchReporteFormulario104({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/reportes/formulario-104', { params: data })
                    .then(response => {
                        commit('setReporteFormulario104', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Reporte XML ATS */
        fetchReporteXmlAts({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/reportes/xml-ats', { params: data })
                    .then(response => {
                        commit('setReporteXmlAts', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Crear cierre SRI */
        postCierreSRI({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/cierre-sri', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Modificar cierre SRI */
        postModificarCierreSRI({ commit }, { id_cierre_sri, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/cierre-sri/${id_cierre_sri}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Ciudades */
        fetchCiudades({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/ciudad', { params: data })
                    .then(response => {
                        commit('setCiudades', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCiudadById({ commit }, id_ciudad) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/tributacion/sri/ciudad/${id_ciudad}`)
                    .then(response => {
                        commit('setCiudades', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearCiudad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/ciudad', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarCiudad({ commit }, { id_ciudad, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/ciudad/${id_ciudad}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarCiudad({ commit }, id_ciudad) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/ciudad/${id_ciudad}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchFideicomisos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/tipo-fideicomiso', { params: data })
                    .then(response => {
                        commit('setFideicomisos', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearFideicomiso({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/tipo-fideicomiso', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarFideicomiso({ commit }, { id_tipo_fideicomiso, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/tipo-fideicomiso/${id_tipo_fideicomiso}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        eliminarFideicomiso({ commit }, id_tipo_fideicomiso) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/tipo-fideicomiso/${id_tipo_fideicomiso}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /* Provincias */
        fetchProvincias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/provincia', { params: data })
                    .then(response => {
                        commit('setProvincias', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        crearProvincia({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/provincia', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        editarProvincia({ commit }, { id_provincia, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/provincia/${id_provincia}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        desactivarProvincia({ commit }, id_provincia) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/provincia/${id_provincia}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchTipoContribuyente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/tipo-contribuyente', { params: data })
                    .then(response => {
                        commit('setTipoContribuyente', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // mantemiento formulario 103
        fetchMantenimientoCodigoForm103({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/sri/formulario-103', { params: data })
                    .then(response => {
                        commit('setCodigoForm103', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchDesactivarCodigoForm103({ commit }, id_formato_103) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/auth/v2/tributacion/sri/formulario-103/${id_formato_103}/cambiar-estado`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAgregarCodigoForm104({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/tributacion/sri/formulario-103', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEditarCodigoForm104({ commit }, { id_formato_103, ...data }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/auth/v2/tributacion/sri/formulario-103/${id_formato_103}`, data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchPorcentajeMatrizRetencion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/tributacion/porcentaje-matriz-retencion', { params: data })
                    .then(response => {
                        commit('setPorcentajeMatrizRetencion', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
})
